import state from "js/state/main"
import scan from "rfuncs/functions/scan"

export default (key, value) => scan((v, k) => (state[key][k] = v), value)
